export enum ProjectProductTypeClassification {
  IGR_LESSER_THAN_3MM = 'IGR_LESSER_THAN_3MM',
  IGR_GREATER_THAN_3MM = 'IGR_GREATER_THAN_3MM',
}
